import { render, staticRenderFns } from "./ConceptPrivacyPolicy.vue?vue&type=template&id=6ccc94d5&scoped=true"
import script from "./ConceptPrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./ConceptPrivacyPolicy.vue?vue&type=script&lang=ts"
import style0 from "./ConceptPrivacyPolicy.vue?vue&type=style&index=0&id=6ccc94d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc94d5",
  null
  
)

export default component.exports